<div class="edit-customer-root">
  <div class="edit-customers-header">
    <div class="user-header-info">
      <div class="user-info">
        <div class="name">
          {{ settlement?.vendorName | hasValue }}
        </div>
        <div class="slrn">
          {{ settlement?.paymentHubSettlementId | hasValue }}
        </div>
        <div class="row info-row">
          <div *ngIf="settlement?.status" class="building-status building-status-margin-right"
            [ngClass]="getStatusClass(settlement?.status)">
            {{ getStatusKey(settlement?.status) | translate }}
          </div>
          <div *ngIf="!settlement?.status" class="building-status-margin-right">
            ----
          </div>
        </div>
      </div>
      <div class="user-address">
        <div>{{ settlement?.amount != null ? ((settlement?.amount | number:'1.2-2') + ' ' + currency) : '----' }}</div>
        <div>{{ settlement?.settlementDate | utcDate }}</div>
      </div>
    </div>
  </div>

  <div class="edit-customers-body">
    <div class="main-col">
      <div class="card container">
        <div class="row">
          <div class="col-5">
            <p class="card-title">{{ 'SETTLEMENTS.SETTLEMENT_INFORMATION' | translate }}</p>
          </div>
          <div class="col-7">
            <div class="line-2"></div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">{{ 'SETTLEMENTS.SETTLEMENT_ID' | translate }}</div>
          <div class="col-8">{{ settlement?.paymentHubSettlementId | hasValue }}</div>
        </div>

        <div class="row">
          <div class="col-5">{{ 'SURVEYS.MAP_VENDOR' | translate }}</div>
          <div class="col-7">{{ settlement?.vendorName | hasValue }}</div>
        </div>

        <div class="row">
          <div class="col-5">{{ 'SETTLEMENTS.NUMBER_OF_TRANSACTIONS' | translate }}</div>
          <div class="col-7">{{ settlement?.transactionsSettled | number }}</div>
        </div>

        <div class="row">
          <div class="col-5">{{ 'COMMON.AMOUNT' | translate }}</div>
          <div class="col-7">{{ settlement?.amount != null ? (settlement?.amount | number:'1.2-2') : '----' }}</div>
        </div>

        <div class="row">
          <div class="col-5">{{ 'PAYMENT_HISTORY.DATE_TIMESTAMP' | translate }}</div>
          <div class="col-7">{{ settlement?.settlementDate | utcDate }}</div>
        </div>
      </div>
    </div>

    <div class="main-col">
      <div class="card container">
        <div class="row">
          <div class="col-5">
            <p class="card-title">{{ 'SETTLEMENTS.STATUS_HISTORY' | translate }}</p>
          </div>
          <div class="col-7">
            <div class="line-2"></div>
          </div>
        </div>

        <div class="row" *ngFor="let event of settlement?.statusHistory">
          <div class="col-5">
            <div class="payment-status" [ngClass]="getStatusClass(event.status)">
              {{ getStatusKey(event.status) | translate }}
            </div>
          </div>
          <div class="col-7">{{ event.receivedAt | utcDate }}</div>
        </div>

        <div class="row" *ngIf="!settlement?.statusHistory?.length">
          <div class="col-12">----</div>
        </div>
      </div>
    </div>
  </div>

  <div class="transactions-root">
    <p class="card-title">{{ 'SETTLEMENTS.TRANSACTIONS' | translate }}</p>

    <div class="transactions-scroll">
      <table class="table border-bottom">
        <thead class="table-light">
          <tr>
            <th id="settlement_details_header_acc-no">{{ 'COMMON.MBC_DETAILS.ACCOUNT_NO' | translate }}</th>
            <th id="settlement_details_header_map-id">{{ 'SURVEYS.MAP_ID' | translate }}</th>
            <th id="settlement_details_header_meter-phase">{{ 'COMMON.MBC_DETAILS.METER_PHASE' | translate }}</th>
            <th id="settlement_details_header_amount">{{ 'COMMON.AMOUNT' | translate }}</th>
            <th id="settlement_details_header_transaction-id">{{ 'SETTLEMENTS.TRANSACTION_ID' | translate }}</th>
            <th id="settlement_details_header_timestamp">{{ 'PAYMENT_HISTORY.DATE_TIMESTAMP' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr [id]="'settlement_details_row-' + (i + 1)" *ngFor="let item of pagedTransactions; let i = index">
            <td>{{ item.accountNumber | hasValue }}</td>
            <td>{{ item.mapId | hasValue }}</td>
            <td>{{ item.meterPhase | hasValue }}</td>
            <td>{{ item.amount | hasValue }}</td>
            <td>{{ item.transactionId | hasValue }}</td>
            <td>{{ item.timestamp | utcDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-paging *ngIf="transactionsCount > 0" [pageSize]="transactionsPageSize" [count]="transactionsCount"
      [currentPage]="transactionsPage" [useDirect]="true" (pageChange)="transactionsPageChange($event)"></app-paging>
  </div>
</div>
